import type { TablesPaginationInfo } from "@wptb/utils/react";
import cn from "classnames";

interface PaginationProps {
  apiData: TablesPaginationInfo;
  setPage: (page: number) => void;
}

const Pagination = ({ apiData, setPage }: PaginationProps) => {
  const paginate = (page: number) => {
    if (
      !apiData ||
      page < 1 ||
      page > apiData.total_pages ||
      page === apiData.current_page
    ) {
      return;
    }
    setPage(page);
  };

  return (
    <div className="wptb-pagination">
      <div className="wptb-pagination-group">
        <button
          type="button"
          className={cn({
            "wptb-pagination-disabled": apiData.current_page === 1,
          })}
          onClick={() => paginate(apiData.current_page - 1)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              d="m15 6l-6 6l6 6"
            />
          </svg>
        </button>
        {apiData.pages.map((page) =>
          page !== 0 ? (
            <button
              key={page}
              type="button"
              className={cn({
                "wptb-pagination-active": page === apiData.current_page,
              })}
              onClick={() => paginate(page)}
            >
              {page}
            </button>
          ) : (
            <p className="wptb-page-divider">...</p>
          )
        )}
        <button
          type="button"
          className={cn({
            "wptb-pagination-disabled":
              apiData.current_page === apiData.total_pages,
          })}
          onClick={() => paginate(apiData.current_page + 1)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              d="m9 6l6 6l-6 6"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
